export default class SvgValidator {
  constructor(file) {
    this.file = file;
  }

  validate() {
    const reader = new FileReader();
    reader.readAsText(this.file);
    return new Promise((resolve, reject) => {
      reader.onloadend = event => {
        if (this.isWithOpacity(event.target.result)) reject();
        else resolve();
      }
    });
  }

  isWithOpacity(svg) {
    const regexp = /opacity/i;
    return regexp.test(svg);
  }
}
